import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Label, FormGroup } from 'reactstrap';
import moment from 'moment';
import { loadScreenings } from '../../../../../redux';
import { EMPTY_ARRAY } from '../../../../../services';
import ScreeningsField from '../../../../ScreeningsField/ScreeningsField';

const FeaturedScreeningSettings = ({ env, screen, widget }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const screenings = useSelector(state => state.screenings?.screenings) || EMPTY_ARRAY;

    useEffect(() => {
        dispatch(loadScreenings({
            start_at_gte: moment().subtract(2, 'years').toISOString(),
            stop_at_lte: moment().add(366, 'days').toISOString(),
        }));
    }, [dispatch]);

    return (
        <FormGroup row className="widget-setting">
            <Label className="col-sm-4">
                { t('settings.mobile.screens.widget.settings.featured_screening_id') }
            </Label>
            <Col sm={ 8 }>
                <ScreeningsField
                    name={ `mobile.${env}.screens.${screen}.widgets[${widget.index}].screening` }
                    screenings={screenings}
                    placeholder={t('settings.mobile.screens.widget.settings.featured_screening_id')}
                    single
                />
            </Col>
        </FormGroup>
    );
}

export default FeaturedScreeningSettings;
